import type { WorksheetGroup } from './worksheet-group-accordion.types';

/** The located worksheet within a worksheet group. */
export type LocatedWorksheet = {
    /** The unique identifier of the worksheet. */
    worksheetId: string;

    /** The name of the worksheet case group that contains the worksheet. */
    groupName?: string;
    /** The worksheet's display name (title) */
    title?: string;
};

/**
 * Locates a worksheet within a group by its submission ID.
 *
 * @param groups - The array of worksheet groups to search within.
 * @param submissionId - The submission ID of the worksheet to locate.
 * @returns The located worksheet, or `undefined` if not found.
 */
export function locateWorksheetBySubmissionId(
    groups: WorksheetGroup[],
    submissionId: string
): LocatedWorksheet | undefined {
    for (const group of groups) {
        const worksheet = group.worksheetTitles.find((ws) => ws.submissionId === submissionId);
        if (worksheet) {
            return {
                worksheetId: worksheet.worksheetId,
                groupName: group?.groupName,
                title: worksheet?.displayName,
            };
        }
    }
    return undefined;
}

/**
 * Locates a worksheet within a group by its worksheet ID.
 *
 * @param groups - The array of worksheet groups to search within.
 * @param worksheetId - The ID of the worksheet to locate.
 * @returns The located worksheet, or `undefined` if not found.
 */
export function locateWorksheetByWorksheetId(
    groups: WorksheetGroup[],
    worksheetId: string
): LocatedWorksheet | undefined {
    for (const group of groups) {
        const worksheet = group.worksheetTitles.find((ws) => ws.worksheetId === worksheetId);
        if (worksheet) {
            return {
                worksheetId: worksheet.worksheetId,
                groupName: group?.groupName,
                title: worksheet?.displayName,
            };
        }
    }
    return undefined;
}
